package io.writeopia.note_menu.ui.screen.file

actual fun fileChooserLoad(title: String): List<String> = emptyList()